// A progress-update import replaces the schedule but keeps the saved
// baseline (Larry item 25). Each new activity takes the baseline of the old
// one in the same place in the outline (phase › name), or of the only old
// activity with that name. Matching on the name alone gave every repeated
// activity the same baseline: Kloepfer schedules have "Remove Sidewalk &
// Curb" under each phase (K3-18, 2026-10-08).

const clean = (s) => String(s || "").trim().toLowerCase()

export function outlinePath(task) {
  const names = []
  for (let t = task; t && !t.isRoot; t = t.parent) names.unshift(clean(t.name))
  return names.join(" › ")
}

function savedBaseline(task) {
  const b = task.baselines
  const first = b && typeof b.count === "number" ? b.first : (Array.isArray(b) ? b[0] : null)
  return first?.startDate && first?.endDate ? first : null
}

// Every old activity's baseline, or its dates when it never had one. A saved
// baseline beats bare dates and the first one wins, so a doubled row (the
// K3-18 duplicates had none) can't replace the real one's.
export function collectBaselines(taskStore) {
  const byPath = new Map(), byName = new Map(), pathsByName = new Map()
  const keep = (map, key, value) => {
    const had = map.get(key)
    if (!had || (!had.saved && value.saved)) map.set(key, value)
  }
  taskStore.forEach((t) => {
    if (!t.isLeaf || !t.name) return
    const saved = savedBaseline(t)
    const startDate = saved?.startDate || t.startDate
    const endDate = saved?.endDate || t.endDate
    if (!startDate || !endDate) return

    const value = { startDate, endDate, saved: !!saved }
    const path = outlinePath(t)
    const name = clean(t.name)
    keep(byPath, path, value)
    keep(byName, name, value)
    if (!pathsByName.has(name)) pathsByName.set(name, new Set())
    pathsByName.get(name).add(path)
  })
  return { byPath, byName, pathsByName }
}

export function baselineFor(collected, task) {
  const exact = collected.byPath.get(outlinePath(task))
  if (exact) return exact

  const name = clean(task.name)
  return collected.pathsByName.get(name)?.size === 1 ? collected.byName.get(name) : null
}
